import { postOxforce, PRODUCT_TYPES } from '@moal/api'
import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import { PRODUCT_MAP } from '../../../constants/products'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import { PRODUCT_CODE } from '../../../utils/ENV'
import { toastSuccess } from '../../../utils/toast'
import { AuthenticationContext } from '../../../context/authenticationContext'

const defaultValues = {
  nickname: '',
  email: '',
  comment: '',
  phone: '',
  franchise: '',
  pub: PRODUCT_CODE, // itemNumber
  source: '',
  sourceURL: ''
}

const Oxforce = ({ user }) => {
  const { user: staff } = useContext(AuthenticationContext)
  const { productsService } = useContext(SiteConfigContext)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState({
    state: false,
    message: ''
  })

  const [data, setData] = useState(defaultValues)

  useEffect(() => {
    if (user && productsService) {
      setData({
        ...data,
        nickname: user.userService.profile.name,
        email: user.userService.email,
        franchise: productsService[PRODUCT_TYPES.ORG].displayName,
        source: `MOAL | ${productsService[PRODUCT_MAP.THIS_PRODUCT].displayName}`,
        sourceURL: productsService[PRODUCT_MAP.THIS_PRODUCT].urls.website,
        senderEmail: staff.userService.email
      })
    }
  }, [user, productsService])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    toastSuccess('Sent to Oxforce.')
    setError({
      state: false,
      message: ''
    })

    const response = await postOxforce({ data })
    if (!response || response.status !== 200) {
      setError({
        state: true,
        message: response.data.message
      })
    }
    setLoading(false)
  }

  return (
    <div className="mx-auto w-full">
      <div className="overflow-y-auto">
        <form
          onSubmit={handleSubmit}
          autoComplete="off"
          className="w-full flex flex-col gap-1"
        >
          <ul className="w-fit flex flex-col gap-2">
            <li className="text-sm">
              <span className="font-semibold">Display Name:</span> {data.name}
            </li>
            <li className="text-sm">
              <span className="font-semibold">Source:</span> {data.itemNumber}
            </li>
          </ul>

          <label className="flex gap-2 items-center dark:text-neutral-50">
            <span className="font-semibold text-sm">Email:</span>
            <input
              value={data.email}
              onChange={(e) =>
                setData((data) => ({ ...data, email: e.target.value }))
              }
              type="email"
              placeholder="Email address"
              required
              className="input w-full"
            />
          </label>

          <label className="flex gap-2 items-center dark:text-neutral-50">
            <span className="font-semibold text-sm">Phone:</span>
            <input
              value={data.phone}
              onChange={(e) =>
                setData((data) => ({ ...data, phone: e.target.value }))
              }
              type="tel"
              placeholder="555-666-7777"
              className="input w-full"
            />
          </label>

          <label className="flex gap-2 items-center dark:text-neutral-50">
            <span className="font-semibold text-sm">Notes:</span>
          </label>
          <textarea
            value={data.comment}
            onChange={(e) =>
              setData((data) => ({ ...data, comment: e.target.value }))
            }
            className="input"
            required
          />

          <div className="flex flex-col">
            {error.state && <p className="text-red-400">{error.message}</p>}
            <input
              type="submit"
              className="button-confirm"
              value={loading ? 'Submitting...' : 'Submit'}
            />
          </div>
        </form>
      </div>
    </div>
  )
}

Oxforce.propTypes = {
  user: PropTypes.object.isRequired
}

export default Oxforce
